import Box from '@mui/material/Box';
import { LoadingButton } from '@mui/lab';
import MultiStepForm from 'components/shared/MultiStepForm/MultiStepForm';
import { useTranslation } from 'react-i18next';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup/dist/yup';
import * as yup from 'yup';
import { ReactNode } from 'react';
import { FormFieldsWrapper } from 'components/shared/AdminSettings/FormFieldsWrapper';
import { Button } from '@mui/material';

export interface AdminSettingsFormProps {
  schema: yup.AnyObjectSchema;
  submitForm: (data: any) => void | Promise<any>;
  children: ReactNode | ReactNode[];
  isLoading: boolean;
  handleSync?: () => void;
  handleSys?: () => void;
  data: unknown | undefined;
  fixedHeightForm?: boolean;
  fullWidth?: boolean;
}

export const AdminSettingsForm = ({
  schema,
  submitForm,
  children,
  isLoading = false,
  data,
  fixedHeightForm = false,
  fullWidth = false,
  handleSync,
  handleSys
}: AdminSettingsFormProps) => {
  const { t } = useTranslation('common');

  const methods = useForm({
    resolver: yupResolver(schema),
    defaultValues: schema.cast(data ?? {})
  });

  return (
    <MultiStepForm
      methods={methods}
      onSubmit={methods.handleSubmit(submitForm)}
      fixedHeight={fixedHeightForm}
      fullHeight={false}
    >
      <FormFieldsWrapper noPadding fullWidth={fullWidth}>
        {children}
      </FormFieldsWrapper>
      <Box pt={handleSync ? 46.5 : handleSys ? 32 : 'unset'}>
        {handleSync && (
          <Button
            sx={{ position: 'absolute' }}
            color="primary"
            variant="outlined"
            onClick={handleSync}
          >
            {t('userAndPassword.syncEmployeeAcc')}
          </Button>
        )}
        {handleSys && (
          <Button
            sx={{ position: 'absolute' }}
            color="primary"
            variant="outlined"
            onClick={handleSys}
          >
            {t('userAndPassword.handleSys')}
          </Button>
        )}
        <Box textAlign="right" pb={3}>
          <LoadingButton
            loading={isLoading}
            type="submit"
            variant="contained"
            color="primary"
          >
            {t('save')}
          </LoadingButton>
        </Box>
      </Box>
    </MultiStepForm>
  );
};
